import request from "./httpService";

const REPORTING_ENDPOINT = '/reporting';

export const reportingService = {
  getInvoiceSalesReport(dateFrom, dateTo, locationId, invoiceType = 'sales', page = 1, limit = 50) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/invoice-sales`,
      params: { dateFrom, dateTo, locationId, invoiceType, page, limit }
    });
  },

   getDispenseReport(dateFrom, dateTo, locationId, page = 1, limit = 50) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/dispense`,
      params: { dateFrom, dateTo, locationId, page, limit }
    });
  },

  getPendingInsuranceClaimsReport(dateFrom, dateTo, locationId, page = 1, limit = 50) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/pending-insurance-claims`,
      params: { dateFrom, dateTo, locationId, page, limit }
    });
  },  
  
  getDailySalesReport(date, locationId = null, page = 1, limit = 50) {
    const params = { date, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales`,
      params: params
    });
  },

  getMonthlySalesReport(year, month, locationId = null, page = 1, limit = 50) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales`,
      params: params
    });
  },

  getInventoryReport(type = null) {
    const params = {};
    if (type) params.type = type;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/inventory`,
      params: params
    });
  },

  getCustomerReport(dateFrom, dateTo, locationId) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/customers`,
      params: { dateFrom, dateTo, locationId }
    });
  },

  getPaymentMethodsReport(dateFrom, dateTo, locationId) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/payment-methods`,
      params: { dateFrom, dateTo, locationId }
    });
  },

  getPaymentsReceivedReport(dateFrom, dateTo, locationId, page = 1, limit = 50) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/payments-received`,
      params: { dateFrom, dateTo, locationId, page, limit }
    });
  },

  getInsuranceReceivedReport(dateFrom, dateTo, locationId, page = 1, limit = 50) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/insurance-received`,
      params: { dateFrom, dateTo, locationId, page, limit }
    });
  },

  getDueEyeExamReport(dateFrom, dateTo, locationId, page = 1, limit = 50) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/due-eye-exam`,
      params: { dateFrom, dateTo, locationId, page, limit }
    });
  },

  getRxDueSoonReport(dateFrom, dateTo, locationId, rxType = 'glasses', page = 1, limit = 50) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/rx-due-soon`,
      params: { dateFrom, dateTo, locationId, rxType, page, limit }
    });
  },

  getRxExpiredReport(dateFrom, dateTo, locationId, rxType = 'glasses', page = 1, limit = 50) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/rx-expired`,
      params: { dateFrom, dateTo, locationId, rxType, page, limit }
    });
  },

  getIndividualCustomerReport(customerId, startDate = null, endDate = null) {
    const params = { customerId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/individual-customer`,
      params: params
    });
  },

  getReportTypes() {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/types`
    });
  },

  // Export methods
  exportDailySalesReportToExcel(date, locationId, page = 1, limit = 200) {
    const params = { date, locationId, page, limit };
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales/export/excel`,
      params: params,
      responseType: 'blob' // Important for file downloads
    });
  },

  exportDailySalesReportToPDF(date, locationId, page = 1, limit = 200) {
    const params = { date, locationId, page, limit };
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales/export/pdf`,
      params: params,
      responseType: 'blob', // Important for file downloads
      headers: {
        'Accept': 'application/pdf'
      }
    });
  },

  // Monthly Sales Export methods
  exportMonthlySalesReportToExcel(year, month, locationId = null, page = 1, limit = 200) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales/export/excel`,
      params: params,
      responseType: 'blob' // Important for file downloads
    });
  },

  exportMonthlySalesReportToPDF(year, month, locationId = null, page = 1, limit = 200) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales/export/pdf`,
      params: params,
      responseType: 'blob', // Important for file downloads
      headers: {
        'Accept': 'application/pdf'
      }
    });
  },

  exportInvoiceSalesReportToExcel(dateFrom, dateTo, locationId, invoiceType = 'sales', page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/invoice-sales/export/excel`,
      params: { dateFrom, dateTo, locationId, invoiceType, page, limit },
      responseType: 'blob'
    });
  },

  exportDispenseReportToExcel(dateFrom, dateTo, locationId, page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/dispense/export/excel`,
      params: { dateFrom, dateTo, locationId, page, limit },
      responseType: 'blob'
    });
  },

  exportPaymentMethodsReportToExcel(dateFrom, dateTo, locationId) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/payment-methods/export/excel`,
      params: { dateFrom, dateTo, locationId },
      responseType: 'blob'
    });
  },

  exportPaymentsReceivedReportToExcel(dateFrom, dateTo, locationId, page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/payments-received/export/excel`,
      params: { dateFrom, dateTo, locationId, page, limit },
      responseType: 'blob'
    });
  },

  exportInsuranceReceivedReportToExcel(dateFrom, dateTo, locationId, page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/insurance-received/export/excel`,
      params: { dateFrom, dateTo, locationId, page, limit },
      responseType: 'blob'
    });
  },

  exportDueEyeExamReportToExcel(dateFrom, dateTo, locationId, page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/due-eye-exam/export/excel`,
      params: { dateFrom, dateTo, locationId, page, limit },
      responseType: 'blob'
    });
  },

  exportRxDueSoonReportToExcel(dateFrom, dateTo, locationId, rxType = 'glasses', page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/rx-due-soon/export/excel`,
      params: { dateFrom, dateTo, locationId, rxType, page, limit },
      responseType: 'blob'
    });
  },

  exportRxExpiredReportToExcel(dateFrom, dateTo, locationId, rxType = 'glasses', page = 1, limit = 200) {
    return request({
      method: 'GET',
      url: `${REPORTING_ENDPOINT}/rx-expired/export/excel`,
      params: { dateFrom, dateTo, locationId, rxType, page, limit },
      responseType: 'blob'
    });
  },

  // Generic export method for future reports
  exportReport(reportType, format, params) {
    const config = {
      method: "GET",
      url: `${REPORTING_ENDPOINT}/${reportType}/export/${format}`,
      params: params,
      responseType: 'blob'
    };

    // Set appropriate Accept header based on format
    if (format === 'pdf') {
      config.headers = { 'Accept': 'application/pdf' };
    } else if (format === 'excel') {
      config.headers = { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
    }

    return request(config);
  }
};

export default reportingService;
